import { useContext } from 'react'
import { useQuery } from 'libs/query'
import { FieldValues, UseFormReturn } from 'libs/form'
import { useAxiosPrivate } from 'shared/hooks'
import { AuthContext } from 'store'
import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import type { BookingRes } from 'features/bookings/types/bookings.types'
import type { Product } from 'features/products/types/products.types'

type UseProductFieldGatesProps = {
	form: UseFormReturn<FieldValues>
	product?: Product
}

export type ProductFieldGates = {
	vatActive: boolean
	supplierActive: boolean
}

export const useProductFieldGates = ({
	form,
	product
}: UseProductFieldGatesProps): ProductFieldGates => {
	const axiosPrivate = useAxiosPrivate()
	const { auth } = useContext(AuthContext)
	const selectedBookingId = form.watch('booking')?.value as number | undefined
	const isProductBooking = !!product && selectedBookingId === product.booking?.id

	const { data: booking } = useQuery<BookingRes>({
		queryKey: queryKeys.bookings.detail(selectedBookingId as number),
		queryFn: () => axiosPrivate.get(apiRoutes.booking(String(selectedBookingId))),
		enabled: !!auth.accessToken && !!selectedBookingId && !isProductBooking
	})

	if (isProductBooking) {
		return {
			vatActive: 'vat_rate' in product,
			supplierActive: 'supplier_sku' in product
		}
	}

	return {
		vatActive: !!booking?.data.vat_active,
		supplierActive: !!booking?.data.supplier_sku_barcode_active
	}
}
